<template>
    <simple-layout>
        <basic-card>
            <template slot="header">Payment batches calendar overview</template>
            <div style="display: flex; justify-content: center;">
                <v-calendar
                        :columns="$screens({default: 1, lg: 4})"
                        :attributes="calendarPaymentBatches"
                >
                    <template slot="day-popover" slot-scope="{ attributes }">
                        <div style="display: flex; flex-flow: column;">
                            <div v-for="attr in attributes" style="">
                                {{attr.customData.displayName}}
                            </div>
                        </div>
                    </template>
                </v-calendar>
            </div>
        </basic-card>
            <basic-card>
                <template slot="header">Payment batches</template>
                <data-table
                    :configuration="batchesTableConfig"
                    :data="batches"
                    @add="addBatch"
                    @focusedChanged="focusedChanged"
                    @payBatch="handlePayBatch"
                    @startBatch="handleStartBatch"
                    @endBatch="handleEndBatch"
                    @approveBatch="handleApproveBatch"
                    @rejectBatch="handleRejectBatch"
                    component-id="payment-batches-list"
                >

                </data-table>
            </basic-card>
        <simple-layout horizontal>
            <payment-batch-form-card
                    :key="focusedBatch.id"
                    v-if="focusedBatch != null"
                    :payment-batch="focusedBatch"
                    @save="savePaymentBatch"/>
        </simple-layout>
        <v-modal name="paymentBatchWorkflowModal" classes="transparent-modal" style="background-color: rgba(10,10,10,0.66)"
                 :width="800" :height="600">
            <basic-card>
                <template slot="header">
                    Payment batch workflow
                </template>
                Following payments will be sent for payment:
                <data-table
                        v-if="modalBatch != null"
                        :data="paymentsByBatch(modalBatch.id)"
                        :configuration="paymentsTableConfiguration"
                        component-id="payment-batch-confirmation-list"
                />
                <br/>
                <simple-button @press="payModalBatch">
                    Pay
                </simple-button>
            </basic-card>
        </v-modal>
    </simple-layout>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import DataTable from "../components/table/DataTable";
    import {mapGetters} from "vuex";
    import FormWrapper from "../components/form/FormWrapper";
    import PaymentBatchFormCard from "../cards/PaymentBatchFormCard";
    import SimpleLayout from "../components/layout/SimpleLayout";
    import PaymentFormCard from "../cards/PaymentFormCard";
    import SimpleButton from "../components/button/SimpleButton";

    export default {
        name: "PaymentBatchesView",
        components: {
            SimpleButton,
            PaymentFormCard, SimpleLayout, PaymentBatchFormCard, FormWrapper, DataTable, BasicCard},
        data: function () {
            return {
                focusedBatch: null,
                modalBatch: null,
                paymentsTableConfiguration: {
                    columns: [
                        {
                            caption: "Date",
                            datum: d => this.$formats.formatDate(d.dueDate)
                        },
                        {
                            caption: "Amount",
                            datum: d => this.$formats.formatNumber(d.amount)
                        },
                        {
                            caption: "Currency",
                            datum: d => d.currencyId
                        },
                        {
                            caption: "Account from",
                            datum: d => d.targetAccountRef != null && this.account(d.sourceAccountRef.accountId) != null ? this.account(d.sourceAccountRef.accountId).name : ""
                        },
                        {
                            caption: "Account to",
                            datum: d => d.targetAccountRef != null && this.account(d.targetAccountRef.accountId) != null ? this.account(d.targetAccountRef.accountId).name : ""
                        }
                    ]
                },
                batchesTableConfig: {
                    enableAdd: true,
                    allowEdit: true,
                    columns: [
                        {
                            caption: "Id",
                            datum: d => d.id
                        },
                        {
                            caption: "Name",
                            datum: d => d.displayName
                        },
                        {
                            caption: "Planned pymt. date",
                            datum: d => this.$formats.formatDate(d.plannedPaymentDate)
                        },
                        {
                            caption: "Payment date",
                            datum: d => "N/A"
                        },
                        {
                            caption: "Description",
                            datum: d => d.description
                        },
                        {
                            caption: "Status",
                            datum: d => d.states[d.states.length - 1].type
                        }
                    ],
                    actions: [
                        {
                            icon: 'money-check',
                            name: 'payBatch',
                            accessLambda: (entry) => {
                                return entry.states[entry.states.length - 1].type === 'WAITING_FOR_PAYMENT' && this.isUserManager
                            },
                            tooltip: "Send batch for payment to bank"
                        },
                        {
                            icon: 'play-circle',
                            name: 'startBatch',
                            accessLambda: (entry) => {
                                return entry.states[entry.states.length - 1].type === 'CREATED' && this.isUserManager
                            },
                            tooltip: "Start work on batch, so payment batch will be enabled for adding payments"
                        },
                        {
                            icon: 'flag-checkered',
                            name: 'endBatch',
                            accessLambda: (entry) => {
                                return entry.states[entry.states.length - 1].type === 'IN_PROGRESS'
                            },
                            tooltip: 'Send for approval'
                        },
                        {
                            icon: 'thumbs-up',
                            name: 'approveBatch',
                            accessLambda: (entry) => {
                                return entry.states[entry.states.length - 1].type === 'WAITING_FOR_APPROVAL' && this.isUserManager
                            },
                            tooltip: "Approve payment batch"
                        },
                        {
                            icon: 'thumbs-down',
                            name: 'rejectBatch',
                            accessLambda: (entry) => {
                                return entry.states[entry.states.length - 1].type === 'WAITING_FOR_APPROVAL' && this.isUserManager
                            },
                            tooltip: "Reject payment batch"
                        }
                    ]
                }
            }
        },
        methods: {
            addBatch() {
                this.focusedBatch = { status: "PLANNED" };
            },
            payModalBatch() {
                this.$store.dispatch("paymentBatches/processWorkflow", {batchId: this.modalBatch.id, action: 'pay', user: this.actualUser.username})
                    .then(() => {
                        this.$notify({
                            group: 'application',
                            title: 'Payment batch sent for processing',
                            text: `Payment batch ${this.modalBatch.displayName} sent for processing`,
                            type: "ok"
                        });
                        this.$modal.hide("paymentBatchWorkflowModal");
                    }).then(() => this.$store.dispatch("paymentBatches/refreshPaymentBatches"))
            },
            savePaymentBatch(paymentBatch) {
                this.$store.dispatch("paymentBatches/savePaymentBatch", paymentBatch)
                    .then(res => {
                        this.$store.dispatch("paymentBatches/refreshPaymentBatches");
                    })
            },
            focusedChanged(focused) {
                this.focusedBatch = focused;
            },
            handleStartBatch(batch) {
                this.$store.dispatch("paymentBatches/processWorkflow",
                    {batchId: batch.id, action: 'start-progress', user: this.actualUser.username})
                    .then(() => this.$store.dispatch("paymentBatches/refreshPaymentBatches"))
            },
            handleEndBatch(batch) {
                this.$store.dispatch("paymentBatches/processWorkflow",
                    {batchId: batch.id, action: 'end-progress', user: this.actualUser.username})
                    .then(() => this.$store.dispatch("paymentBatches/refreshPaymentBatches"))
            },
            handleApproveBatch(batch) {
                this.$store.dispatch("paymentBatches/processWorkflow",
                    {batchId: batch.id, action: 'approve', user: this.actualUser.username})
                    .then(() => this.$store.dispatch("paymentBatches/refreshPaymentBatches"))
            },
            handleRejectBatch(batch) {
                this.$store.dispatch("paymentBatches/processWorkflow",
                    {batchId: batch.id, action: 'reject', user: this.actualUser.username})
                    .then(() => this.$store.dispatch("paymentBatches/refreshPaymentBatches"))
            },
            handlePayBatch(batch) {
                this.modalBatch = batch;
                this.$modal.show("paymentBatchWorkflowModal");
            }
        },
        mounted() {
            this.$store.dispatch("paymentBatches/refreshPaymentBatches");
        },
        watches: {
            '$route': {
                handler(to, from) {
                    this.$store.dispatch("paymentBatches/refreshPaymentBatches");
                }
            }
        },
        computed: {
            ... mapGetters({
                batches: 'paymentBatches/paymentBatches',
                paymentsByBatch: "paymentBatches/paymentsByBatch",
                account: "banking/account",
                actualUser: "auth/actualPrincipal"
            }),
            isUserManager() {
              return this.actualUser.role === 'Manager';
            },
            calendarPaymentBatches() {
                return this.batches.map(batch => ({
                       key: batch.id,
                       bar: true,
                       dates: new Date(batch.plannedPaymentDate),
                        popover: {visibility: 'click'},
                       customData: batch
                    }))

            }
        }
    }
</script>

<style lang="scss" scoped>

</style>